import { render } from "./ProcessPage.vue?vue&type=template&id=8ed15068&scoped=true"
import script from "./ProcessPage.vue?vue&type=script&lang=js"
export * from "./ProcessPage.vue?vue&type=script&lang=js"

import "./ProcessPage.vue?vue&type=style&index=0&id=8ed15068&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed15068"]])

export default __exports__